import { effect, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { MsalService } from '@azure/msal-angular';
import { NavigationService } from './navigation.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AppstateService } from './appstate.service';

@Injectable({
	providedIn: 'root'
})
export class ApplicationService {

	constructor(private authService: AuthService,
		private userService: UserService,
		private navigationService: NavigationService,
		private router: Router
	) {
	}


	public init(): Promise<void> {
		return new Promise<void>((resolve) => {
			// Aufgerufene URL ermitteln (Client-seitig)
			if (sessionStorage.getItem('post_login_redirect') == null) {
				const currentUrl = window.location.href;
				console.log(currentUrl);
				sessionStorage.setItem('post_login_redirect', currentUrl);
			} else {
				sessionStorage.setItem('msalLoginStart', 'x');
			}

			console.log('Initializing app start');
			this.authService.initAuthentication().then(() => {
				console.log('Initializing authentication end');
				this.userService.initUserinfo().then(() => {
					console.log('User info initialized');
					this.userService.userInfoInitialized.set(true);
					console.log('Initializing app end');
					// Nach Redirect: zur zuvor gespeicherten URL navigieren (falls vorhanden)
					const returnUrl = sessionStorage.getItem('post_login_redirect');
					if (returnUrl) {
						sessionStorage.removeItem('post_login_redirect');
						if (sessionStorage.getItem('msalLoginStart')) {
							sessionStorage.removeItem('msalLoginStart');
							this.navigationService.navigateToBudgetantragDashboardFromURL(returnUrl);
						}
					}
					resolve();
				});
			});
		})
	}


}

